import {put, call, takeEvery, select} from 'redux-saga/effects';
import {ASK_LOCATION_PERMISSION_REQUEST, ASK_LOCATION_PERMISSION_SUCCESS} from 'new-constants/permission.constants';
import {loadLocationPermissionStatus, requestLocationPermission} from 'helpers/permission.helper';
import {
	askLocationPermissionFailure,
	askLocationPermissionSuccess,
	loadLocationPermissionStatusFailure,
	loadLocationPermissionStatusRequest,
	loadLocationPermissionStatusSuccess,
} from 'new-actions/permission.actions';
import {SET_ORDER_TYPE_INITIAL} from 'new-constants/ordering-mode.constants';
import {DONE_LOCATION_PERMISSION_CONFIRMATION, OPEN_SELECT_LOCATION} from 'new-constants/popup.constants';

function* triggerLocationPermissionRequest() {
	const state = yield select();
	const {permission} = state;

	let status = null;
	try {
		status = yield call(requestLocationPermission, permission.location.isRequested, permission.location.isGranted);
	} catch (e) {
		yield put(askLocationPermissionFailure(e?.message));
		return;
	}

	if (status) {
		yield put(askLocationPermissionSuccess(status));
	} else {
		yield put(askLocationPermissionFailure());
	}
}

function* refreshPermissionStatus() {
	yield put(loadLocationPermissionStatusRequest());

	let status = null;
	try {
		status = yield call(loadLocationPermissionStatus);
	} catch (e) {
		yield put(loadLocationPermissionStatusFailure(e?.message));
	}

	if (status) {
		yield put(loadLocationPermissionStatusSuccess(status));
	} else {
		yield put(loadLocationPermissionStatusFailure());
	}
}

export const permissionSaga = function* permissionSaga() {
	yield takeEvery(DONE_LOCATION_PERMISSION_CONFIRMATION, triggerLocationPermissionRequest);
	yield takeEvery([SET_ORDER_TYPE_INITIAL, OPEN_SELECT_LOCATION], refreshPermissionStatus);
};
